<div class="checkout-step checkout-payment">
  <div class="checkout-step-content">
    <!-- PIX -->
    <ng-container *ngIf="paymentMethod() === 'PIX'">
      <div class="payment-pix-banner">
        <div class="payment-pix-text">
          <p>{{ 'checkout.payment.pixInfo' | translate }}</p>
        </div>
      </div>
    </ng-container>

    <!-- BOLETO -->
    <ng-container *ngIf="paymentMethod() === 'BOLETO'">
      <form [formGroup]="boletoForm" class="payment-form">
        <div class="form-group">
          <label for="boletoPaymentCondition">
            {{ 'checkout.payment.paymentCondition' | translate }}
            <span class="required">*</span>
          </label>
          <select id="boletoPaymentCondition" formControlName="paymentCondition" class="form-control form-select">
            <option value="">{{ 'checkout.payment.selectCondition' | translate }}</option>
            <option *ngFor="let opt of paymentConditionOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
      </form>
    </ng-container>

    <!-- CREDIT CARD -->
    <ng-container *ngIf="paymentMethod() === 'CREDIT_CARD'">
      <form [formGroup]="creditCardForm" class="payment-form">
        <div class="form-group">
          <label for="ccPaymentCondition">
            {{ 'checkout.payment.paymentCondition' | translate }}
            <span class="required">*</span>
          </label>
          <select id="ccPaymentCondition" formControlName="paymentCondition" class="form-control form-select">
            <option value="">{{ 'checkout.payment.selectCondition' | translate }}</option>
            <option *ngFor="let opt of paymentConditionOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="ccDocument">
            {{ 'checkout.payment.document' | translate }}
            <span class="required">*</span>
          </label>
          <input
            id="ccDocument"
            type="text"
            class="form-control"
            formControlName="cpfCnpj"
            [placeholder]="'checkout.payment.documentPlaceholder' | translate"
            mask="000.000.000-00||00.000.000/0000-00"
          />
        </div>

        <div class="form-group">
          <label for="ccName">
            {{ 'checkout.payment.cardholderName' | translate }}
            <span class="required">*</span>
          </label>
          <input
            id="ccName"
            type="text"
            class="form-control"
            formControlName="cardHolderName"
            [placeholder]="'checkout.payment.cardholderNamePlaceholder' | translate"
          />
        </div>

        <div class="form-group">
          <label for="ccNumber">
            {{ 'checkout.payment.cardNumber' | translate }}
            <span class="required">*</span>
          </label>
          <input
            id="ccNumber"
            type="text"
            class="form-control"
            formControlName="cardNumber"
            [placeholder]="'checkout.payment.cardNumberPlaceholder' | translate"
            mask="0000 0000 0000 0000"
          />
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="ccExpMonth">
              {{ 'checkout.payment.expiryMonth' | translate }}
              <span class="required">*</span>
            </label>
            <select id="ccExpMonth" formControlName="expirationMonth" class="form-control">
              <option value="">MM</option>
              <option *ngFor="let m of months" [value]="m">{{ m }}</option>
            </select>
          </div>

          <div class="form-group">
            <label for="ccExpYear">
              {{ 'checkout.payment.expiryYear' | translate }}
              <span class="required">*</span>
            </label>
            <select id="ccExpYear" formControlName="expirationYear" class="form-control">
              <option value="">AAAA</option>
              <option *ngFor="let y of years" [value]="y">{{ y }}</option>
            </select>
          </div>

          <div class="form-group form-group--cvv">
            <label for="ccCvv">
              CVV
              <span class="required">*</span>
            </label>
            <input id="ccCvv" type="text" class="form-control" formControlName="cvv" placeholder="***" mask="0009" />
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>
